import React from 'react';
import Sidebar from '../components/sidebar';
import { Card, Row, Col, Button, Typography, Divider } from 'antd';
import { CrownOutlined, StarOutlined, RocketOutlined, TrophyOutlined } from '@ant-design/icons';
import './Membresias.css';
import m1Image from '../assets/udgrade/m1.png';
import m2Image from '../assets/udgrade/m2.png';
import m3Image from '../assets/udgrade/m3.png';

const { Title, Text } = Typography;

const Membresias = () => {
  const membresias = [
    {
      id: 'basic',
      nombre: 'KATANA BASIC',
      icono: <StarOutlined />,
      imagen: m1Image,
      precioSinIva: 497,
      precioConIva: null,
      color: '#52c41a',
      botonTexto: 'UpGrade',
      caracteristicas: [
        'Acceso BASIC ACADEMY',
        'Herramientas de Networking',
        'Soporte técnico',
        'Comunidad de usuarios',
        '2 campañas MKTG en simultáneo',
        'Herramientas básicas de negocio',
        'IA dentro de su plataforma',
        'IA agente en sus campañas',
        'Plan de referidos 25% bonificación.',
        'UpGrade'
      ]
    },
    {
      id: 'mentoring',
      nombre: 'KATANA PRO',
      icono: <RocketOutlined />,
      imagen: m2Image,
      precioSinIva: 997,
      precioConIva: null,
      color: '#722ed1',
      botonTexto: 'UPGRADE AHORA',
      caracteristicas: [
        'Todo Basic Business',
        'Acceso MENTORING ACADEMY',
        'Mentoría personalizada',
        'Consultoría estratégica',
        'Acceso a expertos',
        'Sesiones 1 a 1 Coaching',
        'Herramientas avanzadas de negocio',
        '05 campañas MKTG en simultáneo',
        '480 hrs Académicas',
        '288 hrs de mentoría en vivo',
        'Todo Pro Business'
      ]
    },
    {
      id: 'certification',
      nombre: 'KATANA PREMIUM',
      icono: <TrophyOutlined />,
      imagen: m3Image,
      precioSinIva: 1697,
      precioConIva: null,
      color: '#fa8c16',
      botonTexto: 'UPGRADE AHORA',
      caracteristicas: [
        'Acceso CERTIFICATION ACADEMY',
        'Certificación oficial KATANA',
        'Programa de entrenamiento completo',
        'Acceso a contenido exclusivo',
        '10 Campañas MKTG en simultáneo',
        'Generador de contraseñas: Incluido',
        'Certificación Growth Partner.',
        'Certificación Estratega Digital.',
        'Certificación Marketing Digital'
      ]
    }
  ];

  const handleUpgrade = (membresia) => {
    console.log(`Upgrade a ${membresia.nombre}`);
    // Aquí puedes agregar la lógica para procesar el upgrade
    alert(`Procesando upgrade a ${membresia.nombre} - $${membresia.precioSinIva} USD`);
  };

  return (
    <div>
      <Sidebar>
        <div className="membresias-container">
          <div className="text-center mb-4">
            <Title level={3} className="membresias-title">
              🚀 UPGRADE DE MEMBRESÍA
            </Title>
            <Text className="membresias-subtitle">
              Elige el plan que mejor se adapte a tus necesidades
            </Text>
          </div>

          <Row gutter={[24, 24]} justify="center">
            {membresias.map((membresia) => (
              <Col xs={24} sm={12} lg={8} key={membresia.id}>
                <Card
                  className={`membresia-card ${membresia.id}`}
                  hoverable
                  style={{ 
                    border: '2px solid #000000',
                    borderRadius: '16px',
                    height: '100%'
                  }}
                >
                  <div className="text-center mb-3">
                    <div className="mb-3">
                      <img 
                        src={membresia.imagen} 
                        alt={membresia.nombre}
                        style={{
                          width: '100%',
                          maxWidth: '300px',
                          height: 'auto',
                          objectFit: 'contain',
                          borderRadius: '8px'
                        }}
                      />
                    </div>
                    <Title level={4} style={{ color: '#1890ff', margin: '0 0 12px 0' }}>
                      {membresia.nombre}
                    </Title>
                  </div>

                  <div className="precios-container mb-3">
                    <div className="precio-item">
                      <Text strong>SIN I.V.A.</Text>
                      <Title level={4} style={{ margin: '2px 0', color: '#1890ff' }}>
                        USD {membresia.precioSinIva}
                      </Title>
                    </div>
                  </div>

                  <div className="caracteristicas mb-3">
                    {membresia.caracteristicas.map((caracteristica, index) => (
                      <div key={index} className="caracteristica-item">
                        <Text>✓ {caracteristica}</Text>
                      </div>
                    ))}
                  </div>

                  <Button
                    type="primary"
                    size="middle"
                    block
                    style={{
                      backgroundColor: '#000000',
                      borderColor: '#000000',
                      borderRadius: '8px',
                      height: '40px',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}
                    onClick={() => handleUpgrade(membresia)}
                  >
                    {membresia.botonTexto || 'UPGRADE AHORA'}
                  </Button>
                </Card>
              </Col>
            ))}
          </Row>

          <div className="text-center mt-4">
            <Card className="info-card">
              <Title level={5}>💡 ¿Necesitas ayuda para elegir?</Title>
              <Text>
                Nuestro equipo de soporte está disponible para ayudarte.
              </Text>
            </Card>
          </div>
        </div>
      </Sidebar>
    </div>
  );
};

export default Membresias;
